import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07b4a135"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = {
  key: 0,
  class: "file-list-container"
}
const _hoisted_3 = { class: "button-row" }
const _hoisted_4 = {
  key: 1,
  class: "no-data"
}

import { computed, onMounted, ref, watch } from 'vue'
import { Download } from '@element-plus/icons-vue'
import { PaperConfig } from '@/types'
import { getPaperFile } from '@/api/common'
import { ERR_SUCCESS } from '@/api/config'
import { ElButton, ElMessage } from 'element-plus/lib'
import { formatFileSize, shortenText } from '@/hooks/utils/helper'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'DownFile',
  props: {
    item: {},
    isPrimary: { type: Boolean },
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const store = useStore()
const dataList = ref<PaperConfig[]>([])
const downloadButtonRef = ref<InstanceType<typeof ElButton> | null>(null)

// eslint-disable-next-line no-undef
const props = __props
// eslint-disable-next-line no-undef
const emit = __emit
const userInfo = computed(() => store.getters.userInfo)
const item = computed(() => props.item)
const preview = (url: string) => {
  const hasProtocol = url.startsWith('http://') || url.startsWith('https://')
  if (!hasProtocol) {
    url = `https://${url}`
  } else if (url.startsWith('http://')) {
    url = url.replace('http://', 'https://')
  }
  const newUrl = `https://pdf.ke.video/web/viewer.html?file=${encodeURIComponent(url)}`
  emit('update:modelValue', newUrl)
  window.open(newUrl)
}

const isPdf = (url: string) => {
  const fileExtension = url.split('.').pop()?.toLowerCase()
  return fileExtension === 'pdf'
}

async function paperFiles () {
  if (userInfo.value.id) {
    try {
      const idsString = Array.from(props.item.paperfile).join(',')
      const {
        code,
        message,
        result: data
      } = await getPaperFile(idsString)
      if (code === ERR_SUCCESS && data) {
        dataList.value = data
      } else {
        ElMessage.error(message)
      }
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  } else {
    ElMessage.warning('需要登录才能查看下载信息')
  }
}

onMounted(() => {
  if (props.isPrimary && downloadButtonRef.value) {
    downloadButtonRef.value.$el.classList.add('el-button--primary')
  }
})

// eslint-disable-next-line no-return-assign
watch(item, () => dataList.value = [], { deep: true })

return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_text, {
          size: "large",
          tag: "b",
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("当前共有 " + _toDisplayString(item.value.paperfile.length) + " 个附件", 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      (dataList.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item, key) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: key,
                  class: "file-info"
                }, [
                  _createVNode(_component_el_tag, { class: "file-index" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(key + 1), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_link, {
                    href: item.url,
                    class: "file-name",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(shortenText)(item.name, 40)), 1)
                    ]),
                    _: 2
                  }, 1032, ["href"]),
                  _createVNode(_component_el_tag, {
                    class: "file-size",
                    type: "info"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(formatFileSize)(item.size)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(ElButton), {
                    disabled: !isPdf(item.url),
                    size: "small",
                    onClick: ($event: any) => (preview(item.url))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("预览")
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"])
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(ElButton), {
              ref_key: "downloadButtonRef",
              ref: downloadButtonRef,
              icon: _unref(Download),
              type: "primary",
              onClick: paperFiles
            }, {
              default: _withCtx(() => [
                _createTextVNode("查看")
              ]),
              _: 1
            }, 8, ["icon"])
          ]))
    ]),
    _: 1
  }))
}
}

})